<template>
  <page-banner :pageNumber="8" pageName="fixed"/>
  <div class="mainContainer">
    <switch-page-tabbar>
      <nuxt-link to="/xxgk/tzgg">通知公告</nuxt-link>
      <nuxt-link to="/xxgk/gsgg">公示公告</nuxt-link>
    </switch-page-tabbar>
    <list-time-inline :list="state.list" toPath="/xxgk/xq/" v-if="route.path === '/xxgk/tzgg'" />
    <list-inline :list="state.list" toPath="/xxgk/xq/" v-if="route.path === '/xxgk/gsgg'" />
    <pagination :total="state.total" :pageSize="state.pageSize" @changePage="handleRefresh" />
  </div>
</template>


<script setup>
import {getGG} from "../../../apis/xxgk";

const state = reactive({
  list: [],
  total: 0,
  page: 1,
  pageSize: 10,
  typeId: 1
})
const route = useRoute();
// 根据路由，获取公示公告（1）、通知公告（2）相对应的typeId
state.typeId = route.path === '/xxgk/gsgg' ? 2 : 1

// 获取通知、公示公告列表
const {data, refresh} = await useAsyncData("getGGList", () => getGG(state.typeId, state.page, state.pageSize))
if (data.value.code !== 200) {
  throw createError({statusCode: data.value.code, statusMessage: encodeURIComponent("获取信息公开列表失败")})
} else {
  let _data = data.value.data;
  state.list = _data.list
  state.total = _data.total
}

// 翻页
function handleRefresh(value) {
  state.page = value
  refresh()
}

watch(data, (value => {
  if (value.code !== 200) {
    throw createError({statusCode: value.code, statusMessage: encodeURIComponent("获取信息公开列表失败")})
  } else {
    state.total = value.data.total
    state.list = value.data.list
  }
}))

</script>

